import React, { useState } from 'react';
import { MessageBar, MessageBarType, Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import CustomDomainTable from '../Components/CustomDomainTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedDomain, setSelectedDomain] = useState(undefined);
    const [selectedDomainValue, setSelectedDomainValue] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [deleteWarning, setDeleteWarning] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: domains, loading }, refetch] = useAxios("/internal/cobrand/custom-domains");

    if (loading) return <Spinner className="absolute-center" label="Loading Domains..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Redirect Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            {deleteWarning && (
                <MessageBar
                    messageBarType={MessageBarType.severeWarning}
                    onDismiss={() => setDeleteWarning('')}
                    className="mb10"
                >
                    {deleteWarning}
                </MessageBar>
            )}
            <CustomDomainTable
                domains={domains && domains.length > 0 ? domains.sort((a, b) => b.cobrandedUrlId - a.cobrandedUrlId) : []}
                setSelectedDomain={setSelectedDomain}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, domainValue) => {
                    setSelectedDomain(id);
                    setSelectedDomainValue(domainValue || "");
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`internal/cobrand/custom-domains/delete/${selectedDomain}/`}
                onDeleteResult={(data) => {
                    if (data && data.warning) {
                        setDeleteWarning(data.warning);
                        return true;
                    }
                    return false;
                }}
                resourceName={selectedDomainValue}
                resourceType="masked domain"
                confirmationValue={selectedDomainValue || undefined}
            />
        </>
    );
};

export default DefaultPage;
